<template>
  <div class="x_box">
    <ol class="breadcrumb x_breadcrumb">
      <li class="breadcrumb-item active" aria-current="page">{{$t('stock_on_hand_list')}}</li>
    </ol>
    <div class="x_header">
      <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)">
        <i class="fa fa-arrow-circle-o-left"></i>
        {{ $t('back') }}
      </button>
      <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="print">
        <i class="fa fa-print"></i>
        {{$t('print')}}
      </button>
        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="exportExcel">
            <i class="fa fa-file-excel-o" aria-hidden="true"></i>
            {{$t('export_excel')}}
        </button>
    </div>
    <div class="x_body">
      <div class="card x_card">
        <div class="card-body">
          <h4 class="text-center font-m">{{$t('stock_on_hand_list')}}</h4>
          <table class="table table-bordered table-striped table-sm no-bor">
            <thead>
                <tr>
                    <th>{{ $t('no') }}</th>
                    <th>{{ $t('code') }}</th>
                    <th>{{ $t('name') }}</th>
                    <th>{{ $t('category') }}</th>
                    <th>{{ $t('uom') }}</th>
                    <th>{{ $t('branch')}}</th>
                    <th class="text-right">{{ $t('begin_stock')}}</th>
                    <th class="text-right">{{ $t('end_stock') }}</th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="(ret, index) in records" :key="index">
                        <td>{{index+1}}</td>
                        <td>{{ret.ItemCode}}</td>
                        <td>{{ret.ItemName}}</td>
                        <td>{{ret.Category}}</td>
                        <td>{{ret.UomName}}</td>
                        <td>{{ret.BranchName}}</td>
                        <td class="text-right">{{ret.BeginStock}}</td>
                        <td class="text-right">{{ret.Quantity}}</td>
                    </tr>
                </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      records: [],
        query:{
            Page: 1,
            Total: 0,
        },
    };
  },
  created() {
    this.toList();
  },
  methods: {
    toList() {
      var loading = this.$loading.show();
      this.$api()
        .post("report/stock/onhands")
        .then(res => {
            this.records = res.data.Json.StockOnhands;
        })
        .finally(() => {
          loading.hide();
        });
    },
    print() {
        window.open('/print/stock/onhand', '_blank');
    },
      exportExcel(){
          var loading = this.$loading.show();
          this.$api()({
              url: this.$base() + 'report/stock/onhand/export/excel',
              method: 'post',
              data: this.query,
              responseType: 'blob'
          }).then(res => {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', 'report-stock-onhand.xlsx');
              document.body.appendChild(link);
              link.click();
          }).finally(function(){ loading.hide();});
      }
  }
};
</script>
